module.exports = __webpack_public_path__ + "static/media/client-logo-1.ff58db58.jpg";